import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AfterViewInit, Input} from '@node_modules/@angular/core';
declare var $: any;

@Component({
  selector: 'app-countries-flags',
  template:''
})
export class CountriesFlagsComponent implements OnInit, AfterViewInit {
  @Input() input_id: string;
  @Input() onlyCountries = false;
  @Input() dropdownContainer: string;
  @Input() allowDropdown = true;
  @Input() separateDialCode = false;
  @Input() initCountry = 'AU';
  @Output() error = new EventEmitter<any>();
  @Output() selectedCountry = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let telInput = $('#'+this.input_id);
      this.initCountry = this.initCountry && this.initCountry.length > 0 ? this.initCountry : 'AU';
      // console.log(telInput);
      // console.log(this.input_id);
      if (this.onlyCountries === false) {
        telInput.intlTelInput({
          initialCountry: this.initCountry,
          separateDialCode: this.separateDialCode,
          geoIpLookup: function(callback) {
            $.get('https://ipinfo.io', function() {}, 'jsonp').always(function(resp) {
              var countryCode = (resp && resp.country) ? resp.country : '';
              callback(countryCode);
            });
          },
          customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
            this.selectedCountry.emit({countryData: selectedCountryData, placeholder: selectedCountryPlaceholder.replace(/[0-9]/g, "x"), mask: selectedCountryPlaceholder});
          },
          dropdownContainer: this.dropdownContainer,
          allowDropdown: this.allowDropdown,
          utilsScript: '@node_modules/intl-tel-input/build/js/utils.js'
        });
      } else {
        telInput.intlTelInput({
          initialCountry: this.initCountry,
          onlyCountries: true,
          customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
            // console.log(selectedCountryData);
            this.selectedCountry.emit({countryData: selectedCountryData, placeholder: selectedCountryPlaceholder.replace(/[0-9]/g, 'x'), mask: selectedCountryPlaceholder});
          },
          dropdownContainer: this.dropdownContainer,
          allowDropdown: this.allowDropdown,
        });
      }

      telInput.on('change', () => {
        if ((telInput.val() as string).length > 0) {
          let c_phone = telInput.val() as string;
          let phonePlaceholder = telInput.attr('placeholder');

          if (c_phone
            && phonePlaceholder
            && Math.abs(c_phone.replace(/[^0-9.]/g, '').length - phonePlaceholder.replace(/[^x.]/g, '').length) > 0
          ) {
            this.error.emit(telInput.intlTelInput('getValidationError'));
          }
        }
      });
    }, 150);
  }
}
